// tslint:disable:no-inferrable-types
export class User {
  public entitlements?;
  public token?: string;
  public userFullName?: String;
  public lastLogin?;
  public role?: String;
  public firstName?: String;
  public middleInitial?: String;
  public lastName?: String;
  public email: String;
  public socialSecurity?: String;
  public dob?: string;
  public dateOfBirth?;
  public mothersMaidenName?: String;
  public phone?: String;
  public addressLine1?: String;
  public addressLine2?: String;
  public addressLine3?: String;
  public city?: String;
  public state?: String;
  public zip?: String;
  public country?: String;
  public hasSevenSeriesCard?: String;
  public requiresNavyCashEnrollment?: String;
  public hasMultipleAgentRoles?: String;
}
